export interface LaunchDarklyFeatureFlags {
  // Example feature flag - replace with your own
  sampleFeatureEnabled: boolean;
  // Info banner text displayed at the top of the app
  infoBannerText: string;
}

export function parseFeatureFlags(flags: Partial<LaunchDarklyFeatureFlags>) {
  return {
    sampleFeatureEnabled: flags.sampleFeatureEnabled ?? false,
    infoBannerText: flags.infoBannerText ?? "",
  };
}

export type FeatureFlags = ReturnType<typeof parseFeatureFlags>;
